exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#cookieInfo{position:fixed;bottom:0;left:0;right:0;z-index:10000;background:#000;background:rgba(0,0,0,.8);padding:20px 0}#cookieInfo p{color:#fff;line-height:1.1}#cookieInfo p button{padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4d06471d","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/cookiePanel.vue
// module id = CjaF
// module chunks = 6